import { apiFetch, HTTPMethod } from '../fetch';
import { Onboarding } from './interfaces';

export const postMerchantOnboarding = (onboarding: Onboarding) =>
  apiFetch<Onboarding>('/onboardings/merchant', onboarding, HTTPMethod.POST);

export const PostCustomerInitiatedOnboarding = (onboarding: Onboarding) =>
  apiFetch<Onboarding>('/onboardings/initiate', onboarding, HTTPMethod.POST);